<section
  class="rowfiller"
  infiniteScroll
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="150"
  (scrolled)="loadNextPage()"
>
  <div class="card-body p-t-1 px-3">
    <app-microsoccase-list
      class="app-incident"
      [cases]="cases"
      [loaded]="true"
      [scrollLoading]="scrollLoading"
    ></app-microsoccase-list>
  </div>
</section>
